const en = {
  "nav.chefs": "Our Chefs",
  "nav.experiences": "Experiences",
  "nav.privateDining": "Private Dining",
  "nav.journal": "Journal",
  "nav.howItWorks": "How It Works",
  "nav.events": "Events",
  "nav.corporate": "Corporate",
  "nav.bespoke": "Bespoke",
  "nav.giftCards": "Gift Cards",
  "nav.becomeChef": "Become a Chef",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.faq": "FAQ",
  "nav.login": "Sign In",
  "nav.logout": "Sign Out",
  "nav.account": "My Account",
  "nav.findChef": "Find My Chef",
  "nav.more": "More",

  "hero.line1": "Exceptional Cuisine.",
  "hero.line2": "At Your Home.",
  "hero.sub": "Verified private chefs craft five-star dining experiences in the intimacy of your own dining room. Paris and beyond.",
  "hero.badge": "Private Chef Concierge",
  "search.location": "City",
  "search.date": "Date",
  "search.guests": "Guests",
  "search.cuisine": "Cuisine",
  "search.experience": "Experience",
  "search.any": "Any",
  "search.cta": "Find My Chef",

  "home.featuredEyebrow": "The Maison's Selection",
  "home.featuredTitle": "Chefs of Distinction",
  "home.viewAll": "Explore all chefs",
  "home.expEyebrow": "Signature Experiences",
  "home.expTitle": "Six Ways to Dine Remarkably",
  "home.trustEyebrow": "Our Promise",
  "home.trustTitle": "Every Chef, Carefully Selected",
  "home.trustIntro": "Behind every Verified Chef badge stands a rigorous professional verification. We admit only chefs who complete our full review — so your table is always in expert hands.",
  "trust.i1": "Identity verification (KYC)",
  "trust.i2": "Professional experience review",
  "trust.i3": "Profile & portfolio review",
  "trust.i4": "Kitchen practice review",
  "trust.i5": "Dish portfolio tasting standards",
  "trust.i6": "Applicable hygiene documentation",
  "trust.i7": "Banking compliance",
  "home.manifestoEyebrow": "The Manifesto",
  "man.c1t": "The Table Is Sacred",
  "man.c1b": "A dinner at home is not a delivery. It is theatre, hospitality and craft — composed for the people you love, in the place you love most.",
  "man.c2t": "Craft Over Convenience",
  "man.c2b": "Our chefs shop the morning markets, cook in your kitchen and serve course by course. Nothing reheated, nothing rushed, nothing ordinary.",
  "man.c3t": "Trust, Verified",
  "man.c3b": "Every chef on Chef à Domicile passes a professional verification before a single plate is served. Excellence is the entry requirement.",
  "home.marquee": "Private Chef Paris — Chef à Domicile — Luxury Private Dining — Bespoke Menus — Table d'Exception — Five-Star Hospitality —",
  "home.ctaTitle": "Your table deserves a chef.",
  "home.ctaBtn": "Book an Experience",
  "home.journalEyebrow": "The Journal",
  "home.journalTitle": "Stories From the Table",

  "common.verified": "Verified Chef",
  "common.perGuest": "per guest",
  "common.from": "From",
  "common.viewProfile": "View Profile",
  "common.book": "Book",
  "common.loading": "Loading…",
  "common.error": "Something went wrong.",
  "common.retry": "Retry",
  "common.empty": "Nothing here yet.",
  "common.readMore": "Read more",
  "common.back": "Back",
  "common.send": "Send",
  "common.sending": "Sending…",
  "common.yearsExp": "{n} years of experience",
  "common.reviews": "reviews",
  "common.languages": "Languages",
  "common.all": "All",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.add": "Add",
  "common.optional": "optional",
  "common.next": "Continue",
  "common.confirm": "Confirm",
  "common.total": "Total",
  "common.guests": "guests",

  "chefs.title": "The Marketplace of Verified Chefs",
  "chefs.sub": "Curated private chefs, verified by our team, ready to cook at your home.",
  "chefs.filters": "Filters",
  "chefs.clear": "Clear filters",
  "chefs.cuisine": "Cuisine",
  "chefs.city": "City",
  "chefs.minRating": "Minimum rating",
  "chefs.maxPrice": "Max price / guest",
  "chefs.language": "Chef language",
  "chefs.noResults": "No chefs match these criteria. Try widening your search.",
  "chefs.count": "{n} verified chef(s)",

  "chef.about": "About the Chef",
  "chef.signature": "Signature Dishes",
  "chef.reviews": "Guest Reviews",
  "chef.bookThis": "Book this Chef",
  "chef.qualification": "Qualification",
  "chef.allergens": "Allergens",
  "chef.dietary": "Dietary",
  "chef.prep": "{n} min preparation",

  "exp.title": "Signature Experiences",
  "exp.sub": "Six curated ways to bring exceptional cuisine home — from an intimate à la carte dinner to a fully bespoke gastronomic event.",

  "booking.title": "Reserve Your Experience",
  "booking.step1": "Menu",
  "booking.step2": "Details",
  "booking.step3": "Confirm & Pay",
  "booking.selectDish": "Choose a signature dish",
  "booking.date": "Date",
  "booking.time": "Time",
  "booking.address": "Address",
  "booking.city": "City",
  "booking.occasion": "Occasion",
  "booking.requests": "Special requests",
  "booking.create": "Review my booking",
  "booking.promo": "Promo or gift-card code",
  "booking.promoApply": "Apply",
  "booking.promoApplied": "Code applied",
  "booking.chef": "Your Chef",
  "booking.pricePerGuest": "Price per guest",
  "booking.pay": "Proceed to Secure Payment",
  "booking.payNote": "You will be redirected to a secure Stripe checkout. The final amount is computed by our concierge service.",
  "booking.loginFirst": "Please sign in to complete your booking.",
  "booking.stripeOff": "Online payment is temporarily unavailable. Your booking is saved — our concierge will contact you to finalise payment.",
  "booking.discount": "Discount",

  "pay.checking": "Confirming your payment…",
  "pay.success": "Payment confirmed. Your chef has been notified — see you at the table.",
  "pay.failed": "Payment was not completed.",
  "pay.pending": "Payment is still processing. This page will update automatically.",
  "pay.backAccount": "Go to my bookings",

  "auth.loginTitle": "Welcome Back",
  "auth.registerTitle": "Create Your Account",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Full name",
  "auth.loginBtn": "Sign In",
  "auth.registerBtn": "Create Account",
  "auth.toRegister": "New to Chef à Domicile? Create an account",
  "auth.toLogin": "Already a member? Sign in",

  "account.title": "My Account",
  "account.bookings": "Bookings",
  "account.favorites": "Favourites",
  "account.giftcards": "Gift Cards",
  "account.dietary": "Dietary Profile",
  "account.addresses": "Addresses",
  "account.noBookings": "No bookings yet. Your next exceptional dinner awaits.",
  "account.noFavorites": "No favourite chefs yet.",
  "account.status": "Status",
  "account.cancelBooking": "Cancel booking",
  "account.review": "Leave a review",
  "account.reviewComment": "Your comment",
  "account.messages": "Messages",
  "account.writeMsg": "Write a message to your chef…",
  "account.allergies": "Allergies",
  "account.diets": "Diets & preferences",
  "account.saveProfile": "Save profile",
  "account.addAddress": "Add address",
  "account.label": "Label (Home, Office…)",
  "account.noGiftcards": "No gift-card orders yet.",
  "account.commaHint": "Separate with commas",

  "gift.title": "The Gift of an Unforgettable Table",
  "gift.sub": "Offer a private-chef experience. The recipient receives an elegant gift card, redeemable on any booking.",
  "gift.amount": "Amount (€25 – €1000)",
  "gift.recipientName": "Recipient name",
  "gift.recipientEmail": "Recipient email",
  "gift.message": "Personal message",
  "gift.buy": "Purchase Gift Card",
  "gift.note": "The gift-card code is generated and emailed only after the payment is confirmed.",

  "becomeChef.title": "Cook for the Most Beautiful Tables",
  "becomeChef.sub": "Join Chef à Domicile as a private chef. Set your menus, your prices, your calendar — we bring you discerning clients.",
  "becomeChef.cta": "Apply as a Chef",
  "becomeChef.bio": "Your story & culinary background",
  "becomeChef.years": "Years of experience",
  "becomeChef.qualification": "Qualification / training",
  "becomeChef.city": "City",
  "becomeChef.cuisines": "Your cuisines",
  "becomeChef.success": "Application received. Your profile now enters our professional verification workflow — our team will contact you.",
  "becomeChef.s1t": "Apply",
  "becomeChef.s1b": "Tell us about your experience, training and signature cuisine.",
  "becomeChef.s2t": "Get Verified",
  "becomeChef.s2b": "Identity, experience, kitchen practice and portfolio are professionally reviewed.",
  "becomeChef.s3t": "Cook & Earn",
  "becomeChef.s3b": "Receive bookings from refined clients and be paid securely.",

  "inquiry.contactTitle": "Contact the Maison",
  "inquiry.contactSub": "A question, a project, a special request — our concierge replies within 24 hours.",
  "inquiry.corporateTitle": "Corporate Experiences",
  "inquiry.corporateSub": "Executive dinners, client entertainment, team celebrations — cuisine that speaks for your company.",
  "inquiry.corporateCta": "Request a Corporate Experience",
  "inquiry.eventsTitle": "Events of Every Scale",
  "inquiry.eventsSub": "Birthdays, weddings, receptions — a complete culinary production, from menu design to service.",
  "inquiry.eventsCta": "Plan My Event",
  "inquiry.bespokeTitle": "Fully Bespoke Menus",
  "inquiry.bespokeSub": "A one-of-a-kind menu designed with your chef around your story, your produce, your occasion.",
  "inquiry.bespokeCta": "Start a Bespoke Project",
  "inquiry.eventType": "Event type",
  "inquiry.budget": "Budget",
  "inquiry.location": "Location",
  "inquiry.company": "Company",
  "inquiry.phone": "Phone",
  "inquiry.date": "Desired date",
  "inquiry.guests": "Guests",
  "inquiry.message": "Your message",
  "inquiry.success": "Thank you. Our concierge team will be in touch shortly.",

  "how.title": "How It Works",
  "how.sub": "From first click to final course — effortless, in four movements.",
  "how.s1t": "01 — Compose",
  "how.s1b": "Choose your city, date, guests and cuisine. Browse verified chefs and their signature dishes.",
  "how.s2t": "02 — Reserve",
  "how.s2b": "Book in minutes. The price is computed transparently per guest — no hidden fees.",
  "how.s3t": "03 — Welcome Your Chef",
  "how.s3b": "Your chef arrives with fresh produce, cooks in your kitchen and serves course by course.",
  "how.s4t": "04 — Simply Enjoy",
  "how.s4b": "Your chef leaves the kitchen immaculate. You keep the memories — and the compliments.",

  "about.title": "The Maison",
  "about.p1": "Chef à Domicile was born from a simple conviction: the most memorable restaurant in the world is your own home. We connect discerning hosts with verified private chefs who transform a dining room into a five-star table.",
  "about.p2": "From Paris outward, our concierge-grade marketplace curates chefs across 28 world cuisines — each one professionally verified for identity, experience, kitchen practice and portfolio before they ever tie an apron for you.",
  "about.p3": "We are not food delivery. We are hospitality — the craft of the table, brought home.",

  "privateDining.title": "Private Dining, Perfected",
  "privateDining.sub": "Intimate dinners for 2 to 20 guests, orchestrated by a verified private chef.",
  "privateDining.p1": "An evening with Chef à Domicile begins long before the first course. Your chef designs the menu with you, sources the morning's best produce and arrives ready to transform your kitchen into the pass of a fine restaurant.",
  "privateDining.p2": "Course after course is presented at your table — while you stay with your guests. At the end of the night, the kitchen is left immaculate.",
  "privateDining.cta": "Find a Chef for My Dinner",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "How are chefs verified?",
  "faq.a1": "Every chef passes a professional verification: identity (KYC), professional experience, profile review, kitchen practice review, dish portfolio, applicable hygiene documentation and banking compliance. Only verified chefs appear on the marketplace.",
  "faq.q2": "What is included in the price per guest?",
  "faq.a2": "The chef's shopping, preparation, cooking, table service of the menu and kitchen clean-up. The total is computed transparently by our service at booking time.",
  "faq.q3": "Can menus be adapted to allergies or diets?",
  "faq.a3": "Yes. Save allergies and preferences in your dietary profile and add special requests to any booking — your chef adapts the menu.",
  "faq.q4": "How does payment work?",
  "faq.a4": "Payments are processed securely by Stripe. You are only charged once the booking is confirmed; gift cards and promo codes can be applied before checkout.",
  "faq.q5": "Can I cancel a booking?",
  "faq.a5": "Yes, from your account. See our cancellation policy for applicable terms depending on notice period.",

  "journal.title": "The Journal",
  "journal.sub": "Gastronomy, hosting and the art of the table — by Chef à Domicile.",
  "journal.empty": "New stories are being written. Come back soon.",
  "journal.related": "Related Stories",

  "legal.termsTitle": "Terms of Service",
  "legal.privacyTitle": "Privacy Policy",
  "legal.cancelTitle": "Cancellation Policy",
  "legal.terms1": "Chef à Domicile operates a marketplace connecting clients with independent verified private chefs. By using chef-adomicile.com you accept these terms. Bookings form a contract between the client and the chef, facilitated by Chef à Domicile.",
  "legal.terms2": "Prices are displayed per guest; the final total is computed by our service at booking. Payment is processed by our secure payment partner. Chefs are independent professionals responsible for the culinary service delivered.",
  "legal.terms3": "All content, branding and imagery on this site belong to Chef à Domicile. Misuse of the platform, fraudulent bookings or abusive behaviour may lead to account suspension.",
  "legal.privacy1": "We collect only the data needed to operate your account and bookings: identity, contact details, addresses, dietary preferences and booking history. We never sell your data.",
  "legal.privacy2": "Payment data is handled exclusively by our payment partner; Chef à Domicile never stores card numbers. Chefs only receive the information required to deliver your experience.",
  "legal.privacy3": "You may request access, correction or deletion of your personal data at any time by contacting our team via the contact page.",
  "legal.cancel1": "You may cancel a booking from your account. Cancellations made with sufficient notice before the event are refunded according to the conditions communicated at booking.",
  "legal.cancel2": "Late cancellations may incur fees, as the chef will have purchased produce and reserved the date. Gift-card payments are re-credited to the card.",
  "legal.cancel3": "If a chef must cancel, our concierge proposes an equivalent verified chef or a full refund, at your choice.",

  "footer.tag": "Exceptional Cuisine. At Your Home.",
  "footer.explore": "Explore",
  "footer.company": "The Maison",
  "footer.legal": "Legal",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / All rights reserved",

  "seo.homeTitle": "Chef à Domicile — Private Chef at Home | Luxury Private Dining",
  "seo.homeDesc": "Book a verified private chef for an exceptional dinner at home. Luxury private dining in Paris and beyond — bespoke menus, events, corporate experiences.",
};
export default en;
